import React, { useContext, useState } from 'react'
import imgIcon from "../../assets";
import PendingIcon from '@mui/icons-material/Pending';
import { IconDetalis } from "../../common/IconDetalis"
import { useNavigate } from 'react-router-dom';
import { LeftRightlayout } from '../Container/LeftRightlayout';
import Form from '../Components/Form';
import { Input } from '../Components/Input';
import { Icon } from '../../common/CSS';
import { Header } from '../Container/Header';
import { useDispatch, useSelector } from 'react-redux';
import { getLoginOTP, registerWithMobile, setErrorUndefined } from '../../actions/auth';
import FormContextApi from '../../ContextApi'
import { useEffect } from 'react';
import { isLogged } from '../../utils/common';
import axios from "axios";
import { gtag } from 'ga-gtag';

export default function UserDetails() {
    const { userInit, setuserInit } = useContext(FormContextApi);
    const [location, setlocation] = useState({ latitude: '', longitude: '' });
    const { error } = useSelector((store) => store.authreducer);
    const isLoggedIn = isLogged();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const formName = 'userDetailsForm';
    const [form, setForm] = useState(userInit);
    const [showForm, setHideFrom] = useState(false);

    useEffect(() => {
        document.title = 'User Details';
    }, []);

    useEffect(() => {
        if (isLoggedIn) {
            navigate('/service');
        }
        if (form?.address === undefined) {
            getLotion();
        }
    }, []);

    useEffect(() => {
        if (error === 'You are not registered' || error === 'The mobile has already been taken.') {
            setHideFrom(true);
            dispatch(setErrorUndefined());
            setForm({ ...form, user_name: '' });
        }
    }, [error]);

    useEffect(() => {
        if (userInit?.mobile !== form?.mobile && userInit?.mobile.length === 10 && form?.mobile?.length === 10) {
            setForm({ mobile: form?.mobile });
            setHideFrom(false);
        }
    }, [form?.mobile]);


    const onSucessLocation = (location) => {
        setlocation({
            latitude: location.coords.latitude,
            longitude: location.coords.longitude,
        });
    };

    useEffect(() => {
        if (form?.address === undefined) {
            getAddress();
        }
    }, [location]);

    const geolocationOptions = {
        enableHighAccuracy: true,
        maximumAge: 10000,
        timeout: 1000,
    };

    const errorCallback = (error) => {
        console.log(error);
    };

    const getLotion = () => {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(onSucessLocation, errorCallback, geolocationOptions);
        }
    };

    const getAddress = () => {
        if (location.latitude !== '') {
            axios
                .get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${location.latitude},${location.longitude}&sensor=true&key=${process.env.REACT_APP_GOOGLE_API_KEY}`)
                .then((res) => {
                    let address = res.data?.results[0]?.formatted_address;
                    setForm({
                        ...form,
                        address: address,
                    });
                });
        }
    };

    const submit = (form) => {
        if (form?.user_name === '' || form?.user_name === undefined || form.email === '' || form.email === undefined) {
            console.log('ex');
            dispatch(
                getLoginOTP({
                    mobile: form?.mobile,
                    formName: formName,
                    navigate: navigate,
                    gtag: () => {
                        gtag('event', 'Click', {
                            'existing-user-send-otp': 'button',
                        });
                    },
                })
            );
            let update_form = {
                user_name: '',
                email: '',
                mobile: form.mobile,
            };
            setuserInit(update_form);
        } else {
            let [first_name, last_name = ''] = form?.user_name === undefined || form?.user_name === null || form?.user_name === ' ' ? null : form?.user_name?.split(' ');
            let update_form = {
                first_name: first_name,
                last_name: last_name,
                email: form.email,
                mobile: form.mobile,
                address: form.address,
            };
            setuserInit(update_form);
            const newUserGtag = () => {
                gtag('event', 'Click', {
                    'new-user-send-otp': 'button',
                });
            };
            dispatch(registerWithMobile(update_form, 'CUSTOMER', formName, navigate, newUserGtag));
        }
    };

    const Content = () => {
        return (
            <>
                <Header showButton path='/' />
                <div className=' mt-4'>
                    <div className={Icon.HeadingIcon}>
                        <IconDetalis coloreIcon='text-darkblue' IconName='manage_accounts' IconHeading='Your Details' />
                        <IconDetalis coloreIcon='text-stardust' IconName='devices' IconHeading='Select Service' />
                        <IconDetalis coloreIcon='text-stardust' IconName='currency_rupee' IconHeading='Payment' />
                        <IconDetalis coloreIcon='text-stardust' IconName='engineering' IconHeading='Get Engineer' />
                        <div className='w-110F rounded-none bg-darkblue h-3P mt-3 checkBoxPanding'>
                            <PendingIcon />
                        </div>
                        <div className='w-110F rounded-none bg-stardust h-3P mt-3'></div>
                        <div className='w-110F rounded-none bg-stardust h-3P mt-3'></div>
                        <div className='w-full rounded-none bg-stardust h-3P mt-3'></div>
                    </div>
                </div>

                <div className='w-11/12 m-auto mt-2'>
                    <Form btnposition='w-full mt-6' btnText='Next' setForm={setForm} form={form} formName={formName} submit={(form) => submit(form)}>
                        {showForm ? (
                            <>
                                <Input type='text' name='user_name' label='Full Name' required />
                                <Input type='email' name='email' label='Email' required />
                                <Input type='number' name='mobile' label='Mobile Number' required />
                                <Input
                                    type='checkBox'
                                    name='termConditions'
                                    placeholder={
                                        <p className='ml-2 text-1rem font-bold cursor-pointer text-stone-700'>
                                            I accept the{' '}
                                            <span
                                                onClick={() => {
                                                    window.open('https://s3.ap-south-1.amazonaws.com/static.assets.scogo.in/TnC/Scogo_T%26C+and+Privacy+Policy.pdf', '_blank');
                                                }}
                                                className='underline underline-offset-2 hover:text-scogoOrange'
                                            >
                                                {' '}
                                                Terms and Conditions
                                            </span>{' '}
                                        </p>
                                    }
                                    required
                                />
                            </>
                        ) : (
                            <Input type='number' name='mobile' label='Mobile Number' required />
                        )}
                    </Form>
                </div>
            </>
        );
    };

    const Imgsection = () => {
        return (
            <>
                <div className='m-auto h-5/6 w-68P'>
                    <img width='100%' className='m-auto h-5/6 mt-6' src={imgIcon.Yourdetails} alt='' />
                </div>
            </>
        );
    };

    return <LeftRightlayout Content={Content} RightImg={Imgsection} />;
}
